exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".all-brands-banners{margin-top:3rem;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.img-instrinsic-width .all-brands-banners{margin-top:0}.all-brands-banners>div{box-sizing:border-box;text-align:center;margin-bottom:1rem}.all-brands-banners>div img{width:100%}.img-instrinsic-width .all-brands-banners>div img{width:unset;max-width:100%}.all-brands-banners>div p{font-weight:600;font-size:10px;margin-top:1rem}.all-brands-banners>div a:not(.img-cont){display:inline-block;font-weight:700;font-size:10px;text-transform:uppercase;margin:1rem 0 1.5rem;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8faa5f44","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./web/webroot/_ui/responsive/common/js/src/components/allbrandsbanners/allbrandsbanners.scss
// module id = 940
// module chunks = 48